import { render, staticRenderFns } from "./FakeGameActivity.vue?vue&type=template&id=09a4acf5&scoped=true&"
import script from "./FakeGameActivity.vue?vue&type=script&lang=js&"
export * from "./FakeGameActivity.vue?vue&type=script&lang=js&"
import style0 from "./FakeGameActivity.vue?vue&type=style&index=0&id=09a4acf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a4acf5",
  null
  
)

export default component.exports